import { Box, Flex, FormControl, FormErrorMessage, FormLabel, Heading, Input } from '@chakra-ui/react';

export default function CustomerFormParty({ formik }) {
    return (
        <Box w='full'>
            <Box>
                <Heading fontSize={{ base: 'lg', md: 'xl' }}>Party Registration Form</Heading>
            </Box>
            <Box w='full' mt={5}>
                <Flex w='full' flexDirection='column' gap={3}>
                    <Box>
                        <FormControl isRequired isInvalid={!!formik?.errors.partyName && formik?.touched.partyName}>
                            <FormLabel htmlFor='partyName'>Party Name</FormLabel>
                            <Input id='partyName' name='partyName' type='text' onChange={formik.handleChange} value={formik?.values?.partyName ?? ''} size='lg' fontSize='15px' placeholder='e.g. Birthday Party' />
                            <FormErrorMessage>{formik?.errors.partyName}</FormErrorMessage>
                        </FormControl>
                    </Box>
                    <Box>
                        <FormControl isRequired isInvalid={!!formik?.errors.celebrantName && formik?.touched.celebrantName}>
                            <FormLabel htmlFor='celebrantName'>Celebrants Name</FormLabel>
                            <Input id='celebrantName' name='celebrantName' type='text' onChange={formik.handleChange} value={formik?.values?.celebrantName ?? ''} size='lg' fontSize='15px' placeholder='e.g. John Doe' />
                            <FormErrorMessage>{formik?.errors.celebrantName}</FormErrorMessage>
                        </FormControl>
                    </Box>
                    <Box>
                        <FormControl isRequired isInvalid={!!formik?.errors.celebrantAge && formik?.touched.celebrantAge}>
                            <FormLabel htmlFor='celebrantAge'>Celebrants Age</FormLabel>
                            <Input id='celebrantAge' name='celebrantAge' type='text' onChange={formik.handleChange} value={formik?.values?.celebrantAge ?? ''} size='lg' fontSize='15px' placeholder='e.g. 8' />
                            <FormErrorMessage>{formik?.errors.celebrantAge}</FormErrorMessage>
                        </FormControl>
                    </Box>
                    <Box>
                        <FormControl isRequired isInvalid={!!formik?.errors.remarks && formik?.touched.remarks}>
                            <FormLabel htmlFor='remarks'>Remarks</FormLabel>
                            <Input id='remarks' name='remarks' type='text' onChange={formik.handleChange} value={formik?.values?.remarks ?? ''} size='lg' fontSize='15px' placeholder='e.g. Special requests' />
                            <FormErrorMessage>{formik?.errors.remarks}</FormErrorMessage>
                        </FormControl>
                    </Box>
                </Flex>
            </Box>
        </Box>
    );
}
